// extracted by mini-css-extract-plugin
module.exports = {"Acquisition":"Acquisition--3G2vb"};